// @ts-expect-error dependency missing types
import UIAvatar from 'ui-addon-avatars/UIAvatar';
import useUnifiedEventSubmittedUser from '../../hooks/useUnifiedEventSubmittedUser';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ApprovalUnifiedSubmittedUserAvatar(props) {
  const {
    event
  } = props;
  const eventOwner = useUnifiedEventSubmittedUser(event);
  if (!eventOwner) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    style: {
      width: 32
    },
    children: /*#__PURE__*/_jsx(UIAvatar, {
      size: "responsive",
      className: "align-center",
      hubSpotUserEmail: eventOwner.email,
      displayName: eventOwner.email
    })
  });
}